import type { ISbStoryData } from '@storyblok/js';
import lodashIsString from 'lodash-es/isString';
import lodashOmitBy from 'lodash-es/omitBy';

import { STORYBLOK_HOMEPAGE_STORY_DEFAULT_FULL_SLUG } from '#shared/constants/storyblok';
import { defaultLocale } from '~i18n/i18nConfig';

export const resolveStoryblokSlug = (slug: string | string[]): string => {
    if (slug && Array.isArray(slug) && slug.length > 0) {
        return slug.join('/');
    }

    if (lodashIsString(slug) && !!slug) {
        return slug.startsWith('/') ? slug.replace('/', '') : slug;
    }

    return STORYBLOK_HOMEPAGE_STORY_DEFAULT_FULL_SLUG;
};

// Storyblok API return empty values as empty string and not undefined (as defined in the generated type). This function convert empty strings to undefined
export const storyblokOmitEmptyValues = <T extends Record<string, any>>(blok: T): Partial<T> => lodashOmitBy(blok, v => v === '') as Partial<T>;

export const storyblokGetStoryUrl = (story: ISbStoryData): string | undefined => {
    if (story.full_slug === story.default_full_slug) {
        // Default locale, locale prefix must be prepended
        return `/${defaultLocale}/${story.full_slug}`;
    }

    return `/${story.full_slug}`;
};

export const storyblokResolveLink = (link: StoryblokMultilink): string | undefined => {
    if (link.linktype === 'email') {
        return `mailto:${link.email}`;
    }

    if (link.linktype === 'story') {
        const story = link?.story;

        if (!isStoryblokStoryMultilinkUrl(story)) {
            return;
        }

        if (story.full_slug === story.url) {
            // Default locale, locale prefix must be preprended
            return `/${defaultLocale}/${story.full_slug}${link.anchor ? `#${link.anchor}` : ''}`;
        }

        return `/${story.full_slug}${link.anchor ? `#${link.anchor}` : ''}`;
    }

    return link.url; // link.linktype === 'url' || link.linktype === 'asset'
};
